<template>
    <div class="container about">
        <div class="row content text-start pb-3" data-aos="fade-up">
            <div class="col-lg-6">
                <p class="mb-4">
                    Agro Innova is an agribusiness and agri-tech company that leverages digital technology to improve agriculture production, and
                    access to markets for smallholder farmers mostly in rural communities, thereby enhancing economic opportunities and empowering 
                    women and youth. Agro Innova primarily operates in the poultry, maize and soya  value chain working with thousands of farmers 
                    and value chain actors to strengthen agriculture production, improve market linkages and promote inclusive agribusiness development.
                </p>
                <ul>
                    <li><i class="ri-check-double-line"></i> Access to guaranteed markets</li>
                    <li><i class="ri-check-double-line"></i> Input Financing</li>
                    <li><i class="ri-check-double-line"></i> Trainings and Capacity building</li>
                    <li><i class="ri-check-double-line"></i> Farm management software</li>
                    <li><i class="ri-check-double-line"></i> Traceability Software</li>
                    <li><i class="ri-check-double-line"></i> Climate Smart Farming</li>
                </ul>
            </div>
            <div class="col-lg-6 pt-4 pt-lg-0">
                <p>
                    With our in-house developed, farmer-centered technologies, smallholder farmers get to adopt our offline-capable digital solutions 
                    that empower them to manage the day- to -day farm activities on their mobile phones. These solutions help the smallhodler farmers 
                    record and maintain good farm records, make data driven decisions, adopt best farmer practices, become climate resilient and enhance 
                    the overall performance and profitability of their  farming businesses.
                </p>
                <a href="/#Products" class="btn-learn-more">Learn More</a>
            </div>
        </div>
    </div>
    <div class="row cards-bg text-center mt-4">
        <section id="cards" class="cards">
            <div class="container">
                <div class="row d-flex justify-content-center">
                    <div class="p-4 text-center fw-bold fs-3" data-aos="fade-up">
                        <p>WHAT WE HAVE DONE</p>
                    </div>
                    <div class="pattern row d-flex justify-content-center align-items-stretch p-5"> 
                        <div class=" col-lg-3 col-md-6 d-flex justify-content-center align-items-stretch">
                            <div class="member mt-2 mb-3" data-aos="fade-up">
                                <div class="member-info">
                                    <div class="d-flex justify-content-center">
                                        <h4 data-purecounter-start="0" data-purecounter-end="20" data-purecounter-duration="1"
                                                class="counter purecounter"></h4>
                                        <h4>K+</h4>
                                    </div>
                                    <span>Monthly Sales Transactions</span>
                                    <div class="anchor">
                                        <div class="text-start">
                                            <ul>
                                                <li>Poultry Eggs</li>
                                                <li>Maize</li>
                                                <li>Soya Beans</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-3 col-md-6 d-flex justify-content-center align-items-stretch">
                            <div class="member mt-2 mb-3" data-aos="fade-up" data-aos-delay="100">
                                <div class="member-info">
                                    <div class="d-flex justify-content-center">
                                        <h4 data-purecounter-start="0" data-purecounter-end="15" data-purecounter-duration="1"
                                                class="counter purecounter"></h4>
                                        <h4>K+</h4>
                                    </div>
                                    <span>Smallholder Farmers Supported</span>
                                    <div class="anchor">
                                        <div class="text-start">
                                            <ul>
                                                <li>Crop Farmers</li>
                                                <li>Livestock Farmers</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-3 col-md-6 d-flex justify-content-center align-items-stretch">
                            <div class="member mt-2 mb-3" data-aos="fade-up" data-aos-delay="200">
                                <div class="member-info">
                                    <div class="d-flex justify-content-center">
                                        <h4 data-purecounter-start="0" data-purecounter-end="500" data-purecounter-duration="1" class="counter purecounter">
                                        </h4>
                                        <h4>+</h4>
                                    </div>
                                    <span>Direct & Indirect Jobs created</span>
                                    <div class="anchor">
                                        <div class="text-start">
                                            <ul>
                                                <li>Women</li>
                                                <li>Youth</li>
                                                <li>Informal Sector</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-3 col-md-6 d-flex justify-content-center align-items-stretch">
                            <div class="member mt-2 mb-3" data-aos="fade-up" data-aos-delay="300">
                                <div class="member-info">
                                    <div class="d-flex justify-content-center">
                                        <h4 data-purecounter-start="0" data-purecounter-end="10" data-purecounter-duration="1" class="counter purecounter">
                                        </h4>
                                        <h4>+</h4>
                                    </div>
                                    <span>Regions of Operations in Ghana</span>
                                    <div class="anchor">
                                        <div class="d-flex justify-content-center text-start fw-bold">
                                            <div class="p-2">
                                                <div>Greater Accra</div>
                                                <div>Volta</div>
                                                <div>Eastern</div>
                                                <div>Central</div>
                                                <div>Ashanti</div>
                                            </div>
                                            <div class="p-2">
                                                <div>Bono</div>
                                                <div>Oti</div>
                                                <div>Northern</div>
                                                <div>North East</div>
                                                <div>Upper East</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    </div>
</template>

<script>
import PureCounter from '@/assets/vendor/purecounter/purecounter_vanilla';

export default {
    name: "About",
    mounted() {
        this.counterHandler()
    },
    methods: {
        counterHandler(){
            console.log("I am working---------PureCounter")
            new PureCounter();
        }
    }
}
</script>

<style scoped>
/*--------------------------------------------------------------
# About
--------------------------------------------------------------*/
.pattern {
    position: relative;
    z-index: 0;
    background: url("https://res.cloudinary.com/dp9w9miha/image/upload/v1791679238/Pattern.png") center center no-repeat;
    background-size: cover;
}
.about .content {
    position: relative;
    z-index: 0;
}

.about .content h3 {
    font-weight: 600;
    font-size: 26px;
}

.about .content ul {
    list-style: none;
    padding: 0;
}

.about .content ul li {
    padding-left: 28px;
    position: relative;
}

.about .content ul li+li {
    margin-top: 10px;
}

.about .content ul i {
    position: absolute;
    left: 0;
    top: 2px;
    font-size: 20px;
    color: #3db49d;
    line-height: 1;
}

.about .content p:last-child {
    margin-bottom: 0;
}

.about .content .btn-learn-more {
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 1px;
    text-decoration: none;
    display: inline-block;
    padding: 12px 32px;
    border-radius: 5px;
    transition: 0.3s;
    line-height: 1;
    color: #3db49d;
    -webkit-animation-delay: 0.8s;
    animation-delay: 0.8s;
    margin-top: 6px;
    border: 2px solid #3db49d;
}

.about .content .btn-learn-more:hover {
    background: #3db49d;
    color: #fff;
}

/*--------------------------------------------------------------
# Cards
--------------------------------------------------------------*/

.cards {
    color: #2a2c39;
}

.cards .member {
    background-color: #2a2c39;
    border-radius: 5px;
    width: 25rem;
    height: 150px;
}

.cards .member .member-info {
    padding: 25px 15px;
    color: #fff;
}

.cards .member .member-info h4 {
    font-weight: 500;
    margin-bottom: 5px;
    font-family: "Poppins";
    font-size: 40px;
}

.cards .member .member-info .anchor {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    opacity: 0;
    width: auto;
    height: 100%;
    background: #3db49d;
    border-radius: 5px;
    transition: cubic-bezier(0.04, 0.28, 0.58, 1) 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.cards .member:hover .anchor {
    opacity: 1;
}

.cards .member .member-info .anchor li{
    font-weight: bolder;
}

.cards .member .member-info span {
    display: block;
    font-size: 16px;
    font-weight: 400;
}
</style>